/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Val1_DescInputs */

const en_st_val1_desc = /** @type {(inputs: St_Val1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope per feature, phase schedule, hour and price ranges from real verified durations, assumptions and terms — in Indonesian or English, as HTML and PDF.`)
};

const id_st_val1_desc = /** @type {(inputs: St_Val1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang lingkup per fitur, jadwal fase, rentang jam dan biaya dari durasi terverifikasi, asumsi, dan syarat — bahasa Indonesia atau Inggris, HTML dan PDF.`)
};

/**
* | output |
* | --- |
* | "Scope per feature, phase schedule, hour and price ranges from real verified durations, assumptions and terms — in Indonesian or English, as HTML and PDF." |
*
* @param {St_Val1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_val1_desc = /** @type {((inputs?: St_Val1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Val1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_val1_desc(inputs)
	return en_st_val1_desc(inputs)
});